__webpack_require__.S = {};
var initPromises = {};
var initTokens = {};
__webpack_require__.I = (name, initScope) => {
	if(!initScope) initScope = [];
	// handling circular init calls
	var initToken = initTokens[name];
	if(!initToken) initToken = initTokens[name] = {};
	if(initScope.indexOf(initToken) >= 0) return;
	initScope.push(initToken);
	// only runs once
	if(initPromises[name]) return initPromises[name];
	// creates a new share scope if needed
	if(!__webpack_require__.o(__webpack_require__.S, name)) __webpack_require__.S[name] = {};
	// runs all init snippets from all modules reachable
	var scope = __webpack_require__.S[name];
	var warn = (msg) => {
		if (typeof console !== "undefined" && console.warn) console.warn(msg);
	};
	var uniqueName = "portalCommon";
	var register = (name, version, factory, eager) => {
		var versions = scope[name] = scope[name] || {};
		var activeVersion = versions[version];
		if(!activeVersion || (!activeVersion.loaded && (!eager != !activeVersion.eager ? eager : uniqueName > activeVersion.from))) versions[version] = { get: factory, from: uniqueName, eager: !!eager };
	};
	var initExternal = (id) => {
		var handleError = (err) => (warn("Initialization of sharing external failed: " + err));
		try {
			var module = __webpack_require__(id);
			if(!module) return;
			var initFn = (module) => (module && module.init && module.init(__webpack_require__.S[name], initScope))
			if(module.then) return promises.push(module.then(initFn, handleError));
			var initResult = initFn(module);
			if(initResult && initResult.then) return promises.push(initResult['catch'](handleError));
		} catch(err) { handleError(err); }
	}
	var promises = [];
	switch(name) {
		case "default": {
			register("@okta/okta-react", "6.10.0", () => (Promise.all([__webpack_require__.e(5774), __webpack_require__.e(6275), __webpack_require__.e(280), __webpack_require__.e(8816)]).then(() => (() => (__webpack_require__(86275))))));
			register("@playgami/portal-logs", "1.5.0", () => (__webpack_require__.e(9657).then(() => (() => (__webpack_require__(89657))))));
			register("lodash", "4.17.23", () => (__webpack_require__.e(9680).then(() => (() => (__webpack_require__(49680))))));
			register("moment-timezone", "0.5.48", () => (Promise.all([__webpack_require__.e(4070), __webpack_require__.e(4551)]).then(() => (() => (__webpack_require__(75985))))));
			register("react-dom", "18.3.1", () => (Promise.all([__webpack_require__.e(316), __webpack_require__.e(7359)]).then(() => (() => (__webpack_require__(70316))))));
			register("react-redux", "9.2.0", () => (Promise.all([__webpack_require__.e(3828), __webpack_require__.e(9358), __webpack_require__.e(5913)]).then(() => (() => (__webpack_require__(3828))))));
			register("react-router-dom", "5.3.4", () => (Promise.all([__webpack_require__.e(4816), __webpack_require__.e(6220), __webpack_require__.e(6161), __webpack_require__.e(1110)]).then(() => (() => (__webpack_require__(36220))))));
			register("react", "18.3.1", () => (__webpack_require__.e(2155).then(() => (() => (__webpack_require__(22155))))));
			register("redux", "5.0.1", () => (__webpack_require__.e(805).then(() => (() => (__webpack_require__(90805))))));
			initExternal(23894);
			initExternal(28235);
			initExternal(22024);
			initExternal(44812);
		}
		break;
	}
	if(!promises.length) return initPromises[name] = 1;
	return initPromises[name] = Promise.all(promises).then(() => (initPromises[name] = 1));
};